
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blue-bonnet-request",
      function () {
        return require("private-next-pages/blue-bonnet-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blue-bonnet-request"])
      });
    }
  